exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collage-image[data-v-580796f6]{aspect-ratio:1}.black-transparent[data-v-580796f6]:hover{background-color:rgba(3,3,4,.2)}", ""]);

// exports
